import ApiService from './api.service'
import { Error } from './responses/Error';

const StatsTopService = {

    /**
     * Get Stats Top Operating Systems
     *
     * @returns list
     * @throws Error
     **/
    getTopOperatingSystems: async function(forceRefresh: boolean = false) {
        try {

            let attr = (forceRefresh) ? '?forceRefresh=true' : '';
            const response = await ApiService.get('/api/stats-top/operating-systems' + attr);
            return response.data;
        }
        catch (error) {
            throw Error.build(error);
        }
    },

    /**
     * Get Stats Top Browsers
     *
     * @returns list
     * @throws Error
     **/
    getTopBrowsers: async function(page: number = 1, recordsPerPage: number = 10) {
        try {

            let attr = '?page=' + page + '&recordsPerPage=' + recordsPerPage;
            const response = await ApiService.get('/api/stats-top/browsers' + attr);
            return response.data;
        }
        catch (error) {
            throw Error.build(error);
        }
    },

    /**
     * Get Stats Top Browsers Aggregated
     *
     * @returns list
     * @throws Error
     **/
    getTopBrowsersAggregated: async function() {
        try {
            const response = await ApiService.get('/api/stats-top/browsers-aggregated');
            return response.data;
        }
        catch (error) {
            throw Error.build(error);
        }
    },

    /**
     * Get Stats Top IP with Geoloc
     *
     * @returns list
     * @throws Error
     **/
    getTopIP: async function(page: number = 1, recordsPerPage: number = 10) {
        try {

            let attr = '?page=' + page + '&recordsPerPage=' + recordsPerPage;
            const response = await ApiService.get('/api/stats-top/ip-with-geolocation' + attr);
            return response.data;
        }
        catch (error) {
            throw Error.build(error);
        }
    },

    /**
     * Get Stats Top Pobrania Referers
     *
     * @returns list
     * @throws Error
     **/
    getTopPobraniaReferers: async function(page: number = 1, recordsPerPage: number = 10) {
        try {

            let attr = '?page=' + page + '&recordsPerPage=' + recordsPerPage;
            const response = await ApiService.get('/api/stats-top/pobrania-referers' + attr);
            return response.data;
        }
        catch (error) {
            throw Error.build(error);
        }
    },



}

export default StatsTopService

export { StatsTopService }
